import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import imageViewer from '@/components/YLImage/image-viewer.vue';
import { backgroundConfig,
//首页
backgroundConfigByCategory,
// 二级菜单
childBackgroundAdmin,
// 子页面 - 管理员针对渠道
getHeaderConfig,
// 获取头部配置
setHeaderConfig,
// 保存头部配置
getBorderConfig,
// 获取边框配置
setBorderConfig,
// 保存边框配置
getBorderConfigCategory,
// 获取二级边框配置
setBorderConfigCategory,
// 保存二级边框配置
getMenuList } from '../api';
import { getFileInfo } from '@/components/upload/index';
export default {
  components: {
    uploadFile: uploadFile,
    imageViewer: imageViewer
  },
  props: {
    source: {
      type: String,
      default: 'home' // home-装修首页 category-二级 children-子页面 template-模板库
    },
    style_id: [String, Number],
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    backgroundConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    customParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childrenMenuList: Array
  },
  data: function data() {
    return {
      form: {
        home_index_name: '',
        home_show_mode: '',
        background_type: '',
        top_background: '',
        middle_background: '',
        bottom_background: '',
        solid_color_background: ''
      },
      rules: {
        background_type: [{
          required: true,
          message: '背景类型不可为空',
          trigger: 'change'
        }]
      },
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      predefine: ['#ffffff', '#ffebe6', '#f6fcf5', '#f6fbff', '#fffbf5', '#f6f6f6', '#000000'],
      headerForm: {
        header_style: '',
        // 头部样式, 1 文字模式，2 LOGO模式
        // 文字模式相关
        title_type: '',
        // 客户级  1 默认标题 2、自定义标题
        title_name: '',
        title_color: '',
        title_position: '',
        // LOGO模式相关
        logo_type: '',
        // 客户级 1 默认LOGO 2、自定义LOGO
        logo_imageurl: '',
        logo_position: '',
        header_nav: 1,
        // 头部导航 1关闭 2开启
        header_nav_config: [],
        //头部导航菜单配置
        header_nav_button_color: '' // 头部导航按钮颜色
      },
      headerRules: {
        header_style: [{
          required: true,
          message: '请选择头部展示方式',
          trigger: 'change'
        }],
        title_color: [{
          required: true,
          message: '请选择首页标题颜色',
          trigger: 'change'
        }],
        title_position: [{
          required: true,
          message: '请选择展示位置',
          trigger: 'change'
        }],
        logo_position: [{
          required: true,
          message: '请选择展示位置',
          trigger: 'change'
        }],
        header_nav: [{
          required: true,
          message: '请选择头部导航',
          trigger: 'change'
        }],
        header_nav_button_color: [{
          required: true,
          message: '请选择按钮颜色',
          trigger: 'change'
        }]
      },
      headerList: [{
        id: '1',
        name: '文字模式',
        image_url: 'https://res.youlianfuwu.com/mini_program/shop/banner-logo2-eg.jpg'
      }, {
        id: '2',
        name: 'LOGO模式',
        image_url: 'https://res.youlianfuwu.com/mini_program/shop/banner-logo-eg.jpg'
      }],
      headerLoading: false,
      showViewer: false,
      prevOverflow: '',
      previewSrcList: [],
      uploadInfo: {},
      //上传文件信息

      borderFormDisabled: true,
      // 边框设置表单禁用状态
      borderForm: {
        type: 1,
        // 1:通用圆角 2:单独圆角
        broder_general: 10,
        // 通用圆角
        broder_left_top: 10,
        // 左上
        broder_right_top: 10,
        // 右上
        broder_left_bottom: 10,
        // 左下
        broder_right_bottom: 10 // 右下
      },
      borderRules: {
        type: [{
          required: true,
          message: '请选择圆角类型',
          trigger: 'change'
        }],
        broder_general: [{
          required: true,
          pattern: /^[0-9]*$/,
          message: '请输入正整数',
          trigger: 'change'
        }],
        broder_left_top: [{
          required: true,
          pattern: /^[0-9]*$/,
          message: '请输入正整数',
          trigger: 'change'
        }],
        broder_right_top: [{
          required: true,
          pattern: /^[0-9]*$/,
          message: '请输入正整数',
          trigger: 'change'
        }],
        broder_left_bottom: [{
          required: true,
          pattern: /^[0-9]*$/,
          message: '请输入正整数',
          trigger: 'change'
        }],
        broder_right_bottom: [{
          required: true,
          pattern: /^[0-9]*$/,
          message: '请输入正整数',
          trigger: 'change'
        }]
      },
      menuList: [],
      commonHeaderNav: [{
        name: '首页',
        // 菜单名称
        is_home: true // 是否为首页 true-是 false-否
      }, {
        name: '',
        // 菜单名称
        is_home: false,
        // 是否为首页 true-是 false-否
        link_type: '',
        link_value: ''
      }]
    };
  },
  methods: {
    changeProps: function changeProps(item, prop, value) {
      item[prop] = value;
      if (prop === 'logo_position' && value !== 'left') {
        this.headerForm.header_nav = 1;
      }
    },
    // 边框设置 start
    loadBorderData: function loadBorderData() {
      var _this = this;
      var _this$info = this.info,
        channel_id = _this$info.channel_id,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      var params = _objectSpread(_objectSpread(_objectSpread({}, module === 'admin' ? {
        channel_id: channel_id
      } : {}), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
        customer_id: customer_id
      } : {}), {}, {
        style_id: this.style_id
      });
      var req = getBorderConfig;
      if (this.source === 'category') {
        req = getBorderConfigCategory;
        params.category_id = this.info.category_id;
      }
      req(params, module).then(function (res) {
        _this.borderForm = _objectSpread(_objectSpread({}, _this.borderForm), res.data);
      });
    },
    saveBorder: function saveBorder() {
      var _this2 = this;
      this.$refs.borderForm.validate(function (valid) {
        if (valid) {
          var _this2$info = _this2.info,
            channel_id = _this2$info.channel_id,
            customer_id = _this2$info.customer_id,
            module = _this2$info.module;
          var params = _objectSpread(_objectSpread(_objectSpread({}, module === 'admin' ? {
            channel_id: channel_id
          } : {}), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
            customer_id: customer_id
          } : {}), {}, {
            style_id: _this2.style_id
          }, _this2.borderForm);
          var req = setBorderConfig;
          if (_this2.source === 'category') {
            req = setBorderConfigCategory;
            params.category_id = _this2.info.category_id;
          }
          req(params, module).then(function (_) {
            _this2.$message.success('保存成功');
            _this2.borderFormDisabled = true;
            _this2.$emit('updateBorder', _this2.borderForm);
          });
        }
      });
    },
    cancelBorder: function cancelBorder() {
      this.borderFormDisabled = true;
      this.loadBorderData();
    },
    // 边框设置 end
    saveHeader: function saveHeader() {
      var _this3 = this;
      this.$refs.headerForm.validate(function (valid) {
        if (valid) {
          _this3.headerLoading = true;
          var _this3$info = _this3.info,
            channel_id = _this3$info.channel_id,
            customer_id = _this3$info.customer_id,
            module = _this3$info.module;
          var params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this3.headerForm), module === 'admin' ? {
            channel_id: channel_id
          } : {}), ['plat_custom', 'custom'].includes(module) ? {
            customer_id: customer_id
          } : {}), {}, {
            header_nav_config: JSON.stringify(_this3.headerForm.header_nav_config)
          });
          setHeaderConfig(params, module).then(function (_) {
            _this3.$message.success('保存成功');
          }).finally(function () {
            _this3.headerLoading = false;
          });
        }
      });
    },
    deleteLogo: function deleteLogo() {
      var _this4 = this;
      this.$confirm('确认要删除标题LOGO吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: function callback(action) {
          if (action === 'confirm') {
            _this4.headerForm.logo_imageurl = '';
          }
        }
      });
    },
    changeTitleType: function changeTitleType(val, type) {
      var _this$headerForm = this.headerForm,
        channel_home_name = _this$headerForm.channel_home_name,
        channel_title_color = _this$headerForm.channel_title_color,
        channel_title_position = _this$headerForm.channel_title_position,
        chanenl_logo_url = _this$headerForm.chanenl_logo_url,
        channel_logo_position = _this$headerForm.channel_logo_position,
        channel_header_nav = _this$headerForm.channel_header_nav,
        channel_header_nav_config = _this$headerForm.channel_header_nav_config,
        channel_header_nav_button_color = _this$headerForm.channel_header_nav_button_color,
        defined_home_name = _this$headerForm.defined_home_name,
        defined_title_color = _this$headerForm.defined_title_color,
        defined_title_position = _this$headerForm.defined_title_position,
        defined_logo_url = _this$headerForm.defined_logo_url,
        defined_logo_position = _this$headerForm.defined_logo_position,
        defined_header_nav = _this$headerForm.defined_header_nav,
        defined_header_nav_config = _this$headerForm.defined_header_nav_config,
        defined_header_nav_button_color = _this$headerForm.defined_header_nav_button_color;
      if (type === 'title') {
        this.headerForm = _objectSpread(_objectSpread({}, this.headerForm), val == 1 ? {
          title_name: channel_home_name,
          title_color: channel_title_color,
          title_position: channel_title_position
        } : {
          title_name: defined_home_name,
          title_color: defined_title_color,
          title_position: defined_title_position
        });
      } else {
        // 获取的子页面下拉选项为 当前客户 & 所属渠道子页面
        // 当渠道配置为A客户子页面列表，B客户在此处获取下拉列表时，回显渠道配置 无法显示A客户子页面名称
        // 产品要求清空该值
        channel_header_nav_config = channel_header_nav_config.map(function (i) {
          var link_type = i.link_type,
            link_value = i.link_value;
          return _objectSpread(_objectSpread({}, i), {}, {
            link_value: link_type === '3' ? '' : link_value
          });
        });
        this.headerForm = _objectSpread(_objectSpread({}, this.headerForm), val == 1 ? {
          logo_imageurl: chanenl_logo_url,
          logo_position: channel_logo_position,
          header_nav: channel_header_nav,
          header_nav_config: channel_header_nav_config.length > 0 ? channel_header_nav_config : _toConsumableArray(this.commonHeaderNav),
          header_nav_button_color: channel_header_nav_button_color
        } : {
          logo_imageurl: defined_logo_url,
          logo_position: defined_logo_position,
          header_nav: defined_header_nav,
          header_nav_config: defined_header_nav_config.length > 0 ? defined_header_nav_config : _toConsumableArray(this.commonHeaderNav),
          header_nav_button_color: defined_header_nav_button_color
        });
      }
    },
    showPreviewList: function showPreviewList(index) {
      this.prevOverflow = document.body.style.overflow;
      this.previewSrcList = [this.headerList[index].image_url];
      document.body.style.overflow = 'hidden';
      this.showViewer = true;
    },
    closeViewer: function closeViewer() {
      document.body.style.overflow = this.prevOverflow;
      this.showViewer = false;
    },
    loadHeaderData: function loadHeaderData(params, module) {
      var _this5 = this;
      getHeaderConfig(params, module).then(function (res) {
        var _res$data = res.data,
          title_type = _res$data.title_type,
          channel_home_name = _res$data.channel_home_name,
          defined_home_name = _res$data.defined_home_name,
          logo_type = _res$data.logo_type,
          chanenl_logo_url = _res$data.chanenl_logo_url,
          defined_logo_url = _res$data.defined_logo_url;
        res.data.header_nav_config = res.data.header_nav_config.length > 0 ? res.data.header_nav_config : _toConsumableArray(_this5.commonHeaderNav);
        _this5.headerForm = _objectSpread(_objectSpread(_objectSpread({}, _this5.headerForm), res.data), {}, {
          title_name: title_type == '1' ? channel_home_name : defined_home_name,
          logo_imageurl: logo_type == '1' ? chanenl_logo_url : defined_logo_url,
          header_nav_button_color: res.data.header_nav_button_color || '#c20c0c'
        });
      });
      getMenuList({
        styleId: this.style_id
      }).then(function (res) {
        var _res$data2, _res$data2$filter;
        _this5.menuList = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$filter = _res$data2.filter(function (i) {
          return i.used_by_header;
        })) === null || _res$data2$filter === void 0 ? void 0 : _res$data2$filter.map(function (obj) {
          var id = obj.id.split(':')[1] || '';
          obj.disabled = obj.status !== 0 && obj.status !== 1;
          obj.show_name = "".concat(obj.name).concat(id ? "ID".concat(id) : '').concat(obj.alias_name ? "\uFF08".concat(obj.alias_name, "\uFF09") : '');
          return obj;
        })) || [];
      });
    },
    upload: function upload(type) {
      this.$refs['uploadBanner' + type].uploadBanner();
    },
    delImg: function delImg(prop) {
      this.form[prop] = '';
    },
    emitUploadFile: function emitUploadFile(prop, url) {
      this.form[prop] = "".concat(this.$ossurl).concat(url);
    },
    toSave: function toSave() {
      var _this6 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this6.source === 'template') {
            // 模板库页面保存基础设置 返回当前数据
            _this6.$emit('onSave', {
              background_config: _this6.form
            });
            return;
          }
          var _this6$info = _this6.info,
            channel_id = _this6$info.channel_id,
            customer_id = _this6$info.customer_id,
            category_id = _this6$info.category_id,
            module = _this6$info.module;
          var req = backgroundConfig; // 默认装修首页

          var params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this6.form), module === 'admin' ? {
            channel_id: channel_id
          } : {}), ['plat_custom', 'custom'].includes(module) ? {
            customer_id: customer_id
          } : {}), {}, {
            style_id: _this6.style_id
          }, _this6.customParams);
          delete params.home_index_name;
          delete params.home_show_mode;
          if (_this6.source === 'category') {
            // 二级
            req = backgroundConfigByCategory;
            params.category_id = category_id;
            params.home_index_name = _this6.form.home_index_name;
            params.home_show_mode = _this6.form.home_show_mode;
          }
          if (_this6.source === 'children') {
            // 子页面
            req = childBackgroundAdmin;
            params.home_index_name = _this6.form.home_index_name;
          }
          req(params, 'post', module).then(function (res) {
            _this6.$message({
              type: 'success',
              message: '保存成功'
            });
            _this6.$emit('onSave', res.data);
          });
        }
      });
    },
    loadData: function loadData(params, module) {
      var _this7 = this;
      var req = backgroundConfig; // 默认装修首页
      if (this.source === 'category') {
        // 二级
        req = backgroundConfigByCategory;
        params = _objectSpread(_objectSpread({}, params), {}, {
          category_id: this.info.category_id
        });
      }
      if (this.source === 'children') {
        req = childBackgroundAdmin;
      }
      req(_objectSpread(_objectSpread({}, params), this.customParams), 'get', module).then(function (res) {
        if (res.data.background_type) {
          Object.keys(_this7.form).forEach(function (k) {
            _this7.form[k] = res.data[k];
          });
        }
      });
    },
    // 获取图片上传类型等
    getUploadInfo: function getUploadInfo() {
      var _this8 = this;
      getFileInfo().then(function (res) {
        _this8.uploadInfo = res.data;
      });
    }
  },
  created: function created() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this9$info, channel_id, customer_id, module, params;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this9.getUploadInfo(); // 获取图片上传类型等
            _this9.loadBorderData(); // 获取页面边框设置
            if (!(_this9.source === 'template')) {
              _context.n = 1;
              break;
            }
            _this9.form = _objectSpread(_objectSpread({}, _this9.form), _this9.backgroundConfig);
            return _context.a(2);
          case 1:
            _this9$info = _this9.info, channel_id = _this9$info.channel_id, customer_id = _this9$info.customer_id, module = _this9$info.module;
            params = _objectSpread(_objectSpread(_objectSpread({}, module === 'admin' ? {
              channel_id: channel_id
            } : {}), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
              customer_id: customer_id
            } : {}), {}, {
              style_id: _this9.style_id
            });
            _this9.loadData(params, module);
            _this9.loadHeaderData(params, module);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: {
    tips2: function tips2() {
      return {
        children: '子页面顶部标题名称，不填时为空',
        category: '二级首页的标题名称'
      }[this.source];
    }
  }
};